<template>
    <div class="wrapper__landing-page">
        <div class="wrapper__container">
            <div class="wrapper__landing-page__content">
                <p class="wrapper__landing-page__copy">
                    NO PURCHASE NECESSARY. Accepting submissions<br>
                    September 10th and ending September 21st.<br>
                    Open to US residents under age 13.
                </p>
                <button
                    v-trackevent:val="'start-designing_btn'"
                    class="wrapper__btn wrapper__landing-page__button"
                    @click="start"
                ></button>
            </div>
        </div>
    </div>
</template>

<script>
    import bus from '@/services/bus.service';
    import { TrackEvent } from '@/services/track-event.service';

    export default {

        name: 'LandingPage',

        methods: {

            start() {
                TrackEvent.record('Game', 'Started');
                bus.$emit('resetTimeout', true);
                this.$router.push('/mask');
            }
        }
    }
</script>

<style scoped lang="scss">
    .wrapper__landing-page {
        background-image: url('/images/background.png');
        background-repeat: no-repeat;
        background-position: bottom;
        align-items: center;
        justify-content: center;
        display: flex;
        height: 100%;
        position: relative;
        width: 100%;

        &__content {
            background-image: url('/images/landing_container.png');
            background-repeat: no-repeat;
            background-size: 389px 360px;
            height: 450px;
            left: 50%;
            position: absolute;
            transform: translate(-50%, -50%);
            top: 50%;
            width: 389px;
        }

        &__copy {
            bottom: 0px;
            color: #a0912e;
            font-size: 13px;
            font-family: 'Open Sans', sans-serif;
            left: 50%;
            text-align: center;
            position: absolute;
            transform: translateX(-50%);
            width: 328px;
        }

        &__button {
            background-image: url('/images/landing_btn.png');
            top: 312px;
            height: 76px;
            left: 50%;
            position: absolute;
            transform: translateX(-50%);
            width: 250px;

            &:hover {
                background-image: url('/images/landing_btn-hover.png');
            }
        }
    }
</style>
